import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { useQuizMode } from "./quiz-mode-context.js";
import { BooleanQuizAdult } from "./adult/boolean-adult.js";
import { MultiChoiceQuizAdult } from "./adult/multi-choice-adult.js";
import { FillBlankQuizAdult } from "./adult/fill-blank-adult.js";
import { SelectTextQuizAdult } from "./adult/select-text-adult.js";
import { DragTextQuizAdult } from "./adult/drag-text-adult.js";
import { ColoringAdult } from "./adult/coloring-adult.js";
import { CountingAdult } from "./adult/counting-adult.js";
import { ImageSelectQuizAdult } from "./adult/image-select-adult.js";
import { OrderingAdult } from "./adult/ordering-adult.js";
import { PairingAdult } from "./adult/pairing-adult.js";
import { ExplanationQuizAdult } from "./adult/explanation-adult.js";
import { MultiChoiceStudent } from "./student/multi-choice-student.js";
import { BooleanStudent } from "./student/boolean-student.js";
import { FillBlankStudent } from "./student/fill-blank-student.js";
import { SelectTextStudent } from "./student/select-text-student.js";
import { DragTextStudent } from "./student/drag-text-student.js";
import { ColoringStudent } from "./student/coloring-student.js";
import { CountingStudent } from "./student/counting-student.js";
import { ImageSelectStudent } from "./student/image-select-student.js";
import { OrderingStudent } from "./student/ordering-student.js";
import { PairingStudent } from "./student/pairing-student.js";
import { ExplanationStudent } from "./student/explanation-student.js";
import { MultiChoicePrint } from "./print/multi-choice-print.js";
import { BooleanPrint } from "./print/boolean-print.js";
import { FillBlankPrint } from "./print/fill-blank-print.js";
import { SelectTextPrint } from "./print/select-text-print.js";
import { DragTextPrint } from "./print/drag-text-print.js";
import { ColoringPrint } from "./print/coloring-print.js";
import { CountingPrint } from "./print/counting-print.js";
import { ImageSelectPrint } from "./print/image-select-print.js";
import { OrderingPrint } from "./print/ordering-print.js";
import { PairingPrint } from "./print/pairing-print.js";
import { ExplanationPrint } from "./print/explanation-print.js";
import "react";
import "./shared/quiz-blank.js";
import "../../node_modules/.pnpm/katex@0.10.2/node_modules/katex/dist/katex.js";
/* empty css                                                                          */
import "../../node_modules/.pnpm/hls.js@1.6.15/node_modules/hls.js/dist/hls.js";
import "../../utils/quiz-parser.js";
import "../../context/DevToolsContext.js";
const ADULT_MAP = {
  multi_choice: MultiChoiceQuizAdult,
  boolean: BooleanQuizAdult,
  fill_blank: FillBlankQuizAdult,
  short_answer: FillBlankQuizAdult,
  select_text: SelectTextQuizAdult,
  drag_text: DragTextQuizAdult,
  coloring: ColoringAdult,
  counting: CountingAdult,
  image_select: ImageSelectQuizAdult,
  ordering: OrderingAdult,
  pairing: PairingAdult,
  explanation: ExplanationQuizAdult
};
const STUDENT_MAP = {
  multi_choice: MultiChoiceStudent,
  boolean: BooleanStudent,
  fill_blank: FillBlankStudent,
  short_answer: FillBlankStudent,
  select_text: SelectTextStudent,
  drag_text: DragTextStudent,
  coloring: ColoringStudent,
  counting: CountingStudent,
  image_select: ImageSelectStudent,
  ordering: OrderingStudent,
  pairing: PairingStudent,
  explanation: ExplanationStudent
};
const PRINT_MAP = {
  multi_choice: MultiChoicePrint,
  boolean: BooleanPrint,
  fill_blank: FillBlankPrint,
  short_answer: FillBlankPrint,
  select_text: SelectTextPrint,
  drag_text: DragTextPrint,
  coloring: ColoringPrint,
  counting: CountingPrint,
  image_select: ImageSelectPrint,
  ordering: OrderingPrint,
  pairing: PairingPrint,
  explanation: ExplanationPrint
};
const COMPONENT_MAP = {
  adult: ADULT_MAP,
  student: STUDENT_MAP,
  print: PRINT_MAP
};
function QuizRenderer({ quizType, quiz, useKeypad, mode: modeProp, ...rest }) {
  const { t } = useTranslation("quiz");
  const { mode: contextMode } = useQuizMode();
  const mode = modeProp ?? contextMode;
  const modeMap = COMPONENT_MAP[mode];
  const Component = modeMap == null ? void 0 : modeMap[quizType];
  if (!Component) {
    const FallbackComponent = ADULT_MAP[quizType];
    if (FallbackComponent) {
      return /* @__PURE__ */ jsx(FallbackComponent, { quiz, useKeypad, ...rest });
    }
    return /* @__PURE__ */ jsx("div", { className: "p-4 bg-yellow-50 rounded-lg border border-yellow-200", children: /* @__PURE__ */ jsx("p", { className: "text-yellow-800", children: t("container.unsupportedType", { type: quizType }) }) });
  }
  return /* @__PURE__ */ jsx(Component, { quiz, useKeypad, ...rest });
}
export {
  QuizRenderer
};
//# sourceMappingURL=quiz-renderer.js.map
